export let retryButtonText = "nNnTNc";
export default {retryButtonText};